import { ProductsSection } from './ProductsSection';

export default ProductsSection;
